import { call, put } from 'redux-saga/effects';
import { ActionType } from 'deox';

import { checkAccessToken } from '@/utils/handle-authentication';
import { handleAPIError } from '@/utils/handle-api-error';
import { postProjectAction } from '@/redux/actions/project';
import { postProject, TPostProjectResponse } from '@/services/api/project';

// FUNCTION
export function* postProjectSaga(action: ActionType<typeof postProjectAction.request>): Generator {
  const { companyId, successCallback, failedCallback } = action.payload;
  try {
    yield call(checkAccessToken);
    const response = yield call(postProject, companyId);
    const postProjectResponse: TPostProjectResponse = response as TPostProjectResponse;
    yield put(postProjectAction.success(postProjectResponse));
    successCallback?.(postProjectResponse);
  } catch (err) {
    handleAPIError(err, 'Error.getListProjectsByUserError');
    yield put(postProjectAction.failure(err));
    failedCallback?.(err);
  }
}
